import { render } from "./ThemeSwitcher.vue?vue&type=template&id=630437f8&scoped=true"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=js"

import "./ThemeSwitcher.vue?vue&type=style&index=0&id=630437f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630437f8"]])

export default __exports__